export default __webpack_public_path__ + "static/media/24.9d264e47.png";